import { Suspense, lazy } from "react";
// components
import LoadingScreen from "../components/loading-screen";

const Loadable = (Component) => (props) =>
(
  <Suspense fallback={<LoadingScreen width="100px" height="100px" />}>
    <Component {...props} />
  </Suspense>
);

// AUTH
export const LoginPage = Loadable(
  lazy(() => import("../pages/auth/LoginPage"))
);
export const ImpersonationPage = Loadable(
  lazy(() => import("../pages/auth/ImpersonationPage"))
);

// DASHBOARD: GENERAL
export const GeneralAppPage = Loadable(
  lazy(() => import("../pages/dashboard/GeneralAppPage"))
);

// DASHBOARD: STOCK

export const AllStockListPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/AllStockListPage"))
);
export const AddStockPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/stocks/AddStockPage"))
);
export const AllStockEditPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/stocks/AllStockEditPage"))
);

export const LiveStockListPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/stocks/LiveStockListPage"))
);

export const AllAdjustmentListPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/adjustments/AllAdjustmentListPage"))
);

export const AddAdjustmentPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/adjustments/AddAdjustmentPage"))
);

export const AdjustmentEditPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/adjustments/AdjustmentEditPage"))
);

export const AllPurchaseOrderListPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/IMS/purchaseOrder/AllPurchaseOrderListPage")
  )
);

export const AddPurchaseOrderPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/IMS/purchaseOrder/AddPurchaseOrderPage")
  )
);

export const PurchaseOrderEditPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/IMS/purchaseOrder/PurchaseOrderEditPage")
  )
);

export const StockRequestListPage = Loadable(
  lazy(() => import("../pages/dashboard/stocks/StockRequestListPage"))
);

export const StockRequestDetailPage = Loadable(
  lazy(() => import("../pages/dashboard/stocks/StockRequestDetailPage"))
);

export const StockTransferListPage = Loadable(
  lazy(() => import("../pages/dashboard/stocks/StockTransferListPage"))
);

export const StockTransferCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/stocks/StockTransferCreatePage"))
);

export const StockTransferDetailPage = Loadable(
  lazy(() => import("../pages/dashboard/stocks/StockTransferDetailPage"))
);

export const StockReturnListPage = Loadable(
  lazy(() => import("../pages/dashboard/stocks/StockReturnListPage"))
);

export const StockReturnDetailPage = Loadable(
  lazy(() => import("../pages/dashboard/stocks/StockReturnDetailPage"))
);

export const InventoryListPage = Loadable(
  lazy(() => import("../pages/dashboard/inventory/InventoryListPage"))
);

export const StoreItemListPage = Loadable(
  lazy(() => import("../pages/dashboard/stores/StoreItemListPage"))
);

export const StoreListPage = Loadable(
  lazy(() => import("../pages/dashboard/stores/StoreListPage"))
);

export const StoreFormPage = Loadable(
  lazy(() => import("../pages/dashboard/stores/StoreFormPage"))
);


export const AccountsPurchasedOrderListPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/accounts/purchasedOrder/PurchasedOrderListPage")
  )
);

export const AccountsPurchasedOrderCreatePage = Loadable(
  lazy(() =>
    import("../pages/dashboard/accounts/purchasedOrder/PurchasedOrderCreatePage")
  )
);

export const AccountsPurchasedOrderEditPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/accounts/purchasedOrder/PurchasedOrderEditPage")
  )
);

export const AccountsPurchasedOrderDetailPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/accounts/purchasedOrder/PurchasedOrderDetailPage")
  )
);

export const AccountsGoodReceiptNoteListPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/accounts/goodReceiptNote/GoodReceiptNoteListPage")
  )
);

export const AccountsGoodReceiptNoteCreatePage = Loadable(
  lazy(() =>
    import("../pages/dashboard/accounts/goodReceiptNote/GoodReceiptNoteCreatePage")
  )
);

export const AccountsGoodReceiptNoteEditPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/accounts/goodReceiptNote/GoodReceiptNoteEditPage")
  )
);

export const AccountsGoodReceiptNoteDetailPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/accounts/goodReceiptNote/GoodReceiptNoteDetailPage")
  )
);

export const AccountsApInvoiceListPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/accounts/apInvoice/ApInvoiceListPage")
  )
);

export const AccountsApInvoiceCreatePage = Loadable(
  lazy(() =>
    import("../pages/dashboard/accounts/apInvoice/ApInvoiceCreatePage")
  )
);

export const AccountsApInvoiceEditPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/accounts/apInvoice/ApInvoiceEditPage")
  )
);

export const AccountsApInvoiceDetailPage = Loadable(
  lazy(() =>
    import("../pages/dashboard/accounts/apInvoice/ApInvoiceDetailPage")
  )
);

export const AccountsBankingListPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/banking/BankingListPage"))
);
export const AccountsBankingCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/banking/BankingCreatePage"))
);
export const AccountsBankingEditPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/banking/BankingEditPage"))
);
export const AccountsBankingDetailPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/banking/BankingDetailPage"))
);
export const AccountsBankingReturnListPage = Loadable(lazy(() => import("../pages/dashboard/accounts/bankingReturn/BankingReturnListPage")));
export const AccountsBankingReturnCreatePage = Loadable(lazy(() => import("../pages/dashboard/accounts/bankingReturn/BankingReturnCreatePage")));
export const AccountsBankingReturnEditPage = Loadable(lazy(() => import("../pages/dashboard/accounts/bankingReturn/BankingReturnEditPage")));
export const AccountsBankingReturnDetailPage = Loadable(lazy(() => import("../pages/dashboard/accounts/bankingReturn/BankingReturnDetailPage")));
export const AccountsAdvancePaymentListPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/advancePayment/AdvancePaymentListPage"))
);
export const AccountsAdvancePaymentCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/advancePayment/AdvancePaymentCreatePage"))
);
export const AccountsAdvancePaymentEditPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/advancePayment/AdvancePaymentEditPage"))
);
export const AccountsAdvancePaymentDetailPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/advancePayment/AdvancePaymentDetailPage"))
);
export const AccountsAdvancePaymentReturnListPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/advancePaymentReturn/AdvancePaymentReturnListPage"))
);
export const AccountsAdvancePaymentReturnCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/advancePaymentReturn/AdvancePaymentReturnCreatePage"))
);
export const AccountsAdvancePaymentReturnEditPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/advancePaymentReturn/AdvancePaymentReturnEditPage"))
);
export const AccountsAdvancePaymentReturnDetailPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/advancePaymentReturn/AdvancePaymentReturnDetailPage"))
);
export const AccountsPurchaseOrderReturnListPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/purchaseOrderReturn/PurchaseOrderReturnListPage"))
);
export const AccountsPurchaseOrderReturnCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/purchaseOrderReturn/PurchaseOrderReturnCreatePage"))
);
export const AccountsPurchaseOrderReturnEditPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/purchaseOrderReturn/PurchaseOrderReturnEditPage"))
);
export const AccountsPurchaseOrderReturnDetailPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/purchaseOrderReturn/PurchaseOrderReturnDetailPage"))
);
export const AccountsGoodReceiptNoteReturnListPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/goodReceiptNoteReturn/GoodReceiptNoteReturnListPage"))
);
export const AccountsGoodReceiptNoteReturnCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/goodReceiptNoteReturn/GoodReceiptNoteReturnCreatePage"))
);
export const AccountsGoodReceiptNoteReturnEditPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/goodReceiptNoteReturn/GoodReceiptNoteReturnEditPage"))
);
export const AccountsGoodReceiptNoteReturnDetailPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/goodReceiptNoteReturn/GoodReceiptNoteReturnDetailPage"))
);
export const AccountsApInvoiceReturnListPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/apInvoiceReturn/ApInvoiceReturnListPage"))
);
export const AccountsApInvoiceReturnCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/apInvoiceReturn/ApInvoiceReturnCreatePage"))
);
export const AccountsApInvoiceReturnEditPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/apInvoiceReturn/ApInvoiceReturnEditPage"))
);
export const AccountsApInvoiceReturnDetailPage = Loadable(
  lazy(() => import("../pages/dashboard/accounts/apInvoiceReturn/ApInvoiceReturnDetailPage"))
);

//DASHBAORD: INGREDIENT

export const IngredientListPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/ingredients/IngredientListPage"))
);

export const IngredientCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/ingredients/IngredientCreatePage"))
);

export const IngredientEditPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/ingredients/IngredientEditPage"))
);

//DASHBOARD: INVOICE

export const InvoiceListPage = Loadable(
  lazy(() => import("../pages/dashboard/IMS/invoice/InvoiceListPage"))
);

// DASHBOARD: CATALOG
export const CategoryListPage = Loadable(
  lazy(() => import("../pages/dashboard/catalog/CategoryListPage"))
);
export const CategoryDetailPage = Loadable(
  lazy(() => import("../pages/dashboard/catalog/CategoryDetailPage"))
);
export const ProductListPage = Loadable(
  lazy(() => import("../pages/dashboard/catalog/ProductListPage"))
);
export const ProductDetailPage = Loadable(
  lazy(() => import("../pages/dashboard/catalog/ProductDetailPage"))
);

// DASHBOARD: REPORT
export const GeneralReportPage = Loadable(
  lazy(() => import("../pages/dashboard/GeneralReportPage"))
);

// DASHBOARD: Desigination
export const DesiginationCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/DesiginationCreatePage"))
);
export const DesiginationEditPage = Loadable(
  lazy(() => import("../pages/dashboard/DesiginationEditPage"))
);

// DASHBOARD: SETTINGS
export const SettingsCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/SettingsCreatePage"))
);

// DASHBOARD: USER
export const UserListPage = Loadable(
  lazy(() => import("../pages/dashboard/UserListPage"))
);
export const UserAccountPage = Loadable(
  lazy(() => import("../pages/dashboard/UserAccountPage"))
);
export const UserCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/UserCreatePage"))
);
export const UserEditPage = Loadable(
  lazy(() => import("../pages/dashboard/UserEditPage"))
);

// MAIN
export const Page500 = Loadable(lazy(() => import("../pages/Page500")));
export const Page403 = Loadable(lazy(() => import("../pages/Page403")));
export const Page404 = Loadable(lazy(() => import("../pages/Page404")));


// Supplier
export const SupplierListPage = Loadable(
  lazy(() => import("../pages/dashboard/SupplierListPage"))
);
export const SupplierCreatePage = Loadable(
  lazy(() => import("../pages/dashboard/SupplierCreatePage"))
);
export const SupplierEditPage = Loadable(
  lazy(() => import("../pages/dashboard/SupplierEditPage"))
);
